﻿'use strict';

import React from 'react';
import { useState, useEffect, useRef, useCallback } from 'react';

import Carousel from 'react-bootstrap/Carousel';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';




import useRequest from '../helper/useRequest';
import { toast, ToastContainer } from 'react-toastify';
import Alert from '../helper/Alert';

import Loader from '../helper/Loader';


import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';



const Testimonials = () => {
    const { request } = useRequest();

    const [index, setIndex] = useState(0);
    const [testimonials, setTestimonials] = useState(false);

    const swiperRef = useRef(null);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    const fetchData = async () => {
        try {
            let result = await request("/Home/GetTestimonials");
            let json = result.data;
            if (json.r != 1) {
                if (json.message) {
                    toast.error(json.message);
                }
                else {
                    toast.error("Beim Laden der Testimonials ist ein Fehler aufgetreten.");
                }
            }
            else {
                setTestimonials(json.testimonials);
            }
        }
        catch (ex) {
            console.error(ex);
            toast.error("Beim Laden der Testimonials ist ein Fehler aufgetreten.");
        }
    };

    const handlePrev = useCallback(() => {
        if (!swiperRef.current) return;
        swiperRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!swiperRef.current) return;
        swiperRef.current.swiper.slideNext();
    }, []);

    useEffect(() => {
        fetchData();
    }, []);

    if (testimonials === false) return <Loader />

    return (
        <>
            <div className="testimonial-swiper-wrapper d-flex justify-content-center align-items-center">
                <div className="testimonial-swiper-prev" onClick={handlePrev}>
                    <i className="fas fa-chevron-left text-light display-4"></i>
                </div>
                <div className="testimonial-container">
                    <Swiper
                        ref={swiperRef}
                        className="testimonial-swiper"
                        modules={[Navigation, Pagination, A11y, Autoplay]}
                        navigation={false}
                        pagination={false}
                        spaceBetween={50}
                        slidesPerView={1}
                        loop={true}
                        onSlideChange={() => console.log('slide change')}
                        onSwiper={(swiper) => console.log(swiper)}
                        autoplay={{
                            delay: 7000,
                            disableOnInteraction: true,
                        }}
                    >
                        {
                            testimonials.map((item) => {
                                if (!item.IsEnabled) return null;

                                return (
                                    <SwiperSlide key={item.TestimonialID}>
                                        <div className="testimonial-slide text-center text-light">
                                            <h3 className="testimonial-title font-weight-bold mb-3">{item.Feedback}</h3>
                                            <div className="testimonial-info">{item.Person}, {item.Function}</div>
                                        </div>
                                    </SwiperSlide>
                                )
                            }
                            )
                        }
                    </Swiper>
                </div>
                <div className="testimonial-swiper-next" onClick={handleNext}>
                    <i className="fas fa-chevron-right text-light display-4"></i>
                </div>
            </div >

            <ToastContainer position="bottom-left" autoClose={50000} />
        </>

    );
}


/*
 
const Testimonials = () => {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    return (
        <Carousel activeIndex={index} onSelect={handleSelect} indicators={false}>
            <Carousel.Item>
                <Carousel.Caption>
                    <h3>Brühler Eisenwerk</h3>
                    <hr />
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <Carousel.Caption>
                    <h3>Svenja Toth</h3>
                    <div class="carousel-subtitle">Lehrerin Elisabeth von Thüringen Schule</div>
                    <hr />
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <Carousel.Caption>
                    <h3>Antje Knick</h3>
                    <div class="carousel-subtitle">Personalabteilung Phantasialand</div>
                    <hr />
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.</p>
                </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
                <Carousel.Caption>
                    <h3>Matthias</h3>
                    <div class="carousel-subtitle">Lehrer Elisabeth von Thüringen Schule</div>
                    <hr />
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet.</p>
                </Carousel.Caption>
            </Carousel.Item>
        </Carousel>
    );
}

*/

export default Testimonials;